import React, { createContext, useState } from "react";
import languages from "../data/translation.json";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState("en");

    const changeLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage, texts: languages[language] }}>
            {children}
        </LanguageContext.Provider>
    );
};